// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"cab6798c03dc89b8a82f","293":"36b5989496fa890aa210"}[chunkId] + ".js";
};